module.exports = __webpack_public_path__ + "6a25c7a0dcdd6c280675c118c39d40a7.png";